import { Injectable } from '@angular/core';

import { AzavistaApiService } from '@azavista/servicelib';
import { IField } from '@azavista/components/shared';
import { IConfirmationDialogComponentData } from '../../shared/confirmation-dialog/confirmation-dialog.interfaces';
import { TranslationKey } from '../../shared/enums';
import { SharedService } from '../../shared/shared.service';

@Injectable({
    providedIn: 'root'
})
export class ContactsService {
    constructor(
        private apiSvc: AzavistaApiService, private sharedSvc: SharedService
    ) {
    }

    async showDeleteContactConfirmation(): Promise<IConfirmationDialogComponentData> {
        return this.sharedSvc.showConfirmationDialog(
            this.sharedSvc.translate(TranslationKey.deleteContactDialogTitle),
            [
                this.sharedSvc.translate(TranslationKey.onlyContactsWhoAreNotInAnEventWillBeDeleted),
                this.sharedSvc.translate(TranslationKey.deleteContactDialogAreYouSure),
                this.sharedSvc.translate(TranslationKey.wontBeAbleToRestoreData)
            ]
        );
    }

    async deleteContactsWithConfirmation(ids: string[]): Promise<IConfirmationDialogComponentData> {
        const confirmResult = await this.showDeleteContactConfirmation();
        if (!confirmResult) {
            return confirmResult;
        }
        const promises = [];
        for (const id of ids) {
            promises.push(this.apiSvc.deleteContact(id));
        }
        await Promise.all(promises);
        return confirmResult;
    }

    async getAllContactFields(): Promise<IField[]> {
        // TODO: We must cache this but it requires a dummy component for the CRM module so it can have ngOnDestroy
        const allFields: IField[] = await this.apiSvc.getAllContactFields();
        this.sharedSvc.sortAlphabetically(allFields, (item) => item.label);
        // Set editable flag so the cells are editable
        for (const field of allFields) {
            // TODO: Is every cell editable ?
            field.editable = true;
        }
        const orgRelationId = this.sharedSvc.getOrganizationRelationFakeFieldId();
        allFields.push({
            component: 'relation', editable: true, id: orgRelationId, name: orgRelationId,
            label: this.sharedSvc.translate(TranslationKey.organization), schema: { type: ['string', 'object'] }
        } as IField);
        const orgNameId = this.sharedSvc.getOrganizationNameFakeFieldId();
        allFields.push({
            editable: false, id: orgNameId, name: orgNameId,
            label: this.sharedSvc.translate(TranslationKey.organization), schema: { type: 'string' }
        } as IField);
        return allFields;
    }
}
